const Footer = () => {
 
  return (
    <div
      className={` w-full px-4 py-2 text-justify 
      flex  justify-center items-center text-xs bg-[#2F4B7C] text-white `} >
      Maintained by DPHE. Designed and Developed by Tiller and GWSC. 
    </div>
  );
};

export default Footer;